import Hero from '../components/Hero';
import '../styles/AboutUs.css';

const valueCards = [
  {
    title: 'Innovation',
    desc: 'We invest in research and development to deliver innovative solutions that drive tangible business outcomes.',
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 2a4 4 0 0 0-2.4 7.2c.6.45.95 1.05 1.02 1.8h2.76c.07-.75.42-1.35 1.02-1.8A4 4 0 0 0 12 2zm-1.4 10.5v.9h2.8v-.9h-2.8zM10 15.2c0 .5.4.9.9.9h2.2c.5 0 .9-.4.9-.9v-.6h-4v.6zm.9 2.1c.28.72.98 1.2 1.1 1.2s.82-.48 1.1-1.2h-2.2z"
        />
        <path fill="currentColor" d="M12 20.5c-.9 0-1.7-.5-2-1.2h4c-.3.7-1.1 1.2-2 1.2z" />
      </svg>
    )
  },
  {
    title: 'Agility',
    desc: 'We embrace agility in our processes, allowing us to deliver projects on time and within budget.',
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
        <path
          fill="currentColor"
          d="M21.7 18.3l-6.1-6.1a5.5 5.5 0 0 0-6.7-6.9l2.9 2.9-2.1 2.1-2.9-2.9a5.5 5.5 0 0 0 6.9 6.7l6.1 6.1a1 1 0 0 0 1.4 0l.5-.5a1 1 0 0 0 0-1.4z"
        />
        <path
          fill="currentColor"
          d="M8.2 13.9l-5.9 5.9a1.3 1.3 0 0 0 1.9 1.9l5.9-5.9a7.6 7.6 0 0 1-1.9-1.9z"
        />
      </svg>
    )
  },
  {
    title: 'Growth Trajectory',
    desc: 'Our commitment to excellence, coupled with a strong focus on innovation and customer satisfaction.',
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
        <path
          fill="currentColor"
          d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm0 1.5c-3 0-6 1.5-6 3.6V19h8.3a6.5 6.5 0 0 1-.3-2c0-1.6.6-3.1 1.6-4.2A11 11 0 0 0 9 12.5z"
        />
        <path
          fill="currentColor"
          d="M22 17a4.4 4.4 0 0 0-.06-.7l1.06-.8-1-1.7-1.24.5a4.4 4.4 0 0 0-1.2-.7l-.2-1.3h-2l-.2 1.3c-.44.16-.85.4-1.2.7l-1.24-.5-1 1.7 1.06.8a4.4 4.4 0 0 0 0 1.4l-1.06.8 1 1.7 1.24-.5c.35.3.76.54 1.2.7l.2 1.3h2l.2-1.3c.44-.16.85-.4 1.2-.7l1.24.5 1-1.7-1.06-.8c.04-.23.06-.46.06-.7zm-3.7 1.6a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2z"
        />
      </svg>
    )
  }
];

function WhyChooseIllustration() {
  return (
    <svg className="about-illustration" viewBox="0 0 520 470" role="img" aria-label="Illustration of a person working at a desk">
      <defs>
        <linearGradient id="blobGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fde4ef" />
          <stop offset="100%" stopColor="#fbd0e4" />
        </linearGradient>
        <linearGradient id="hairGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f0559b" />
          <stop offset="100%" stopColor="#8e4bd0" />
        </linearGradient>
        <linearGradient id="bubbleGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#b06cf0" />
          <stop offset="100%" stopColor="#7b5ce8" />
        </linearGradient>
      </defs>

      {/* soft background blob */}
      <path
        fill="url(#blobGrad)"
        d="M300 20c70 0 128 52 137 122 9 68-26 118-72 158-46 40-104 76-160 58C143 339 96 292 84 232 70 162 96 92 152 52 194 22 250 20 300 20z"
      />

      {/* floor tiles */}
      <path fill="#fce7f1" d="M118 372l108-58 96 52-108 58z" />
      <path fill="#fce7f1" d="M300 306l86-46 74 40-86 46z" />

      {/* leaves */}
      <g fill="#bcdcf7">
        <path d="M396 214c22 22 26 60 8 92-30-16-44-54-32-84 6-6 16-10 24-8z" />
        <path d="M440 258c16 24 14 58-6 80-22-20-26-56-10-78 4-4 12-6 16-2z" />
        <path d="M148 386c20 24 22 62 2 92-30-18-40-58-26-88 5-7 17-9 24-4z" />
        <path d="M196 420c14 22 12 52-5 72-20-18-24-50-9-70 4-4 11-5 14-2z" />
      </g>

      {/* desk */}
      <path fill="#f6a8c8" d="M172 268h190v14H172z" />
      <path fill="#ffffff" d="M172 254h190v14H172z" />
      <path fill="#f3d9e6" d="M172 282l40 26h190l-40-26z" />

      {/* laptop / tablet on desk */}
      <rect x="212" y="236" width="52" height="16" rx="2" fill="#dbe9f8" />
      <rect x="216" y="240" width="44" height="8" rx="1" fill="#ffffff" />
      <rect x="286" y="238" width="38" height="14" rx="2" fill="#c9def4" />

      {/* seated figure */}
      <path fill="#7fb2e8" d="M226 300c14-10 34-12 48-4l52 30-16 12-56-24-28 10z" />
      <path fill="#9ec8f2" d="M232 306l52 28-8 46-40 8-16-46z" />
      <path fill="#2e3f88" d="M258 176c26-10 54 4 62 30 8 26-6 52-28 60l-56-16c-6-28 0-64 22-74z" />
      <path fill="url(#hairGrad)" d="M242 158c22-18 56-14 70 8 12 20 6 46-6 66-10-6-14-22-14-38-14 8-32 10-46 2-10-10-12-28-4-38z" />
      <circle cx="288" cy="200" r="26" fill="#ffd0b3" />
      <path fill="url(#hairGrad)" d="M262 194c-4-24 12-44 34-46 20-2 34 12 36 28-16-2-28 4-38 14-10 10-22 10-32 4z" />
      <path fill="#ffd0b3" d="M312 236l32 14-8 16-38-18z" />
      <rect x="330" y="238" width="42" height="26" rx="4" fill="#eaf3fd" transform="rotate(-14 330 238)" />

      {/* legs & shoes */}
      <path fill="#bcd9f6" d="M244 348l44 12-8 62-30-4z" />
      <path fill="#3a4bb5" d="M248 414l30 4-2 20-32-4z" />

      {/* floating icon bubbles */}
      <g>
        <path fill="#cfe4fb" d="M104 190c26-24 66-14 76 16 8 26-12 52-40 54-30 2-54-24-48-52 2-8 6-14 12-18z" />
        <path fill="#ffffff" d="M126 216l30 18-30 18z" />
      </g>
      <g>
        <path fill="url(#bubbleGrad)" d="M330 86c22-18 56-8 62 20 6 24-12 46-36 46-26 0-44-24-36-48 2-7 5-13 10-18z" />
        <path fill="#ffffff" d="M358 108l12 14h-7v14h-10v-14h-7z" />
        <rect x="348" y="140" width="24" height="4" rx="2" fill="#ffffff" />
        <rect x="348" y="148" width="24" height="4" rx="2" fill="#ffffff" />
      </g>
      <g>
        <path fill="url(#bubbleGrad)" d="M120 300c18-16 46-8 52 14 6 20-8 38-28 38-22 0-38-18-32-38 1-6 4-11 8-14z" />
        <path
          fill="#ffffff"
          d="M146 310l2 6 6 2-6 2-2 6-2-6-6-2 6-2zm-2 12a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
        />
      </g>
    </svg>
  );
}

function AboutUs({ setCurrentPage }) {
  return (
    <>
    <Hero title="About Us" image="/images/techno1.png" compact />
    <div className="about-page">
      {/* Why Choose Us */}
      <section className="why-choose">
        <div className="why-choose-media">
          <WhyChooseIllustration />
        </div>

        <div className="why-choose-content">
          <h2>Why Choose Us</h2>
          <p>
            Digicloudllc is one of the fastest growing global IT, engineering services and
            solutions company revolutionizing digital transformations. We believe in enabling
            clients to maximize the potential and achieve a greater market with a wide array of
            technology services, include Enterprise Resource Planning, Application Development,
            Analytics, Digital, and the Internet of things (IoT).
          </p>
          <p>
            At Digicloudllc, our mission is to revolutionize the way businesses leverage
            technology. We strive to empower our clients with the most advanced solutions,
            enabling them to thrive in a rapidly evolving digital landscape. We truly believe in
            one global team, also we embrace innovative mindset and change to deliver value
            continuously.
          </p>
          <p>
            Digicloudllc enhances patient care, optimizes health outcomes, and reduces healthcare
            costs through strategic healthcare consulting. They offer comprehensive staffing
            services across specialties like Acute Care, Allied Health, Medical Administration,
            Social Services, and Long-Term Care. Digicloudllc improves patient care, health
            outcomes, and cost efficiency through strategic healthcare consulting and specialized
            staffing services.
          </p>
        </div>
      </section>

      <div className="about-cta">
        <button type="button" className="learn-more-btn" onClick={() => setCurrentPage && setCurrentPage('Contact')}>
          Learn More
        </button>
      </div>

      {/* Unleash the power */}
      <section className="unleash">
        <h2 className="unleash-title">
          Unleash the power of
          <br />
          digital transformation
        </h2>
        <p>
          A global technology solution company with a focus on creating enterprise cloud software
          and the best-in-class workforce solutions. We help you build your business as if it’s our
          own.
        </p>
        <p>
          Building a state-of-art digital transformation journey along with providing you with
          workforce solutions for any industry sector is our expertise but we also pride ourselves
          on our excellent customer service.
        </p>
      </section>

      {/* Value cards */}
      <section className="values-cards">
        {valueCards.map((card) => (
          <div className="values-card" key={card.title}>
            <span className="values-card-icon">{card.icon}</span>
            <div className="values-card-body">
              <h4>{card.title}</h4>
              <p>{card.desc}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
    </>
  );
}

export default AboutUs;
